import {
  ActivityEvent,
  ActivityMember,
  ActivityMemberEvent,
  ActivityMembers,
  EventAction,
  EventActions,
  EventShortlistAction,
  EventShortlistActions
} from "PFTypes";

import { ActivityHistoryFilters } from "./context";

export const hasActiveFilters = (filters: ActivityHistoryFilters): boolean =>
  filters.eventType.length > 0 ||
  filters.operatorId.length > 0 ||
  !!filters.createdAtMin ||
  !!filters.createdAtMax;

export const isActivityMemberEvent = (entry: ActivityEvent): entry is ActivityMemberEvent => {
  const [prefix, suffix] = entry.event.split("_");

  return (
    (ActivityMembers.includes(prefix as ActivityMember) && EventActions.includes(suffix as EventAction)) ||
    (EventShortlistActions.includes(suffix as EventShortlistAction) && prefix === "shortlist")
  );
};
